import { render, staticRenderFns } from "./BaseGarantizados2.vue?vue&type=template&id=3ed03cf0&"
import script from "./BaseGarantizados2.vue?vue&type=script&lang=js&"
export * from "./BaseGarantizados2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports